import React from 'react';
import { Link } from 'react-router-dom';
import SidebarDropDownOption from '../../../../components/SidebarDropDownOption';
import SubMenu from "../../../../components/Sidebar/SubMenu";
import ContractorTabsApp from "../Functionality/ContractorTabsApp";
import CommonTabsApp from "../Functionality/CommonTabsApp";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */


const ContractorTabs = ({ isMenuOpen }) => {
    const props = CommonTabsApp();
    const { openMenu, changeStyle, setChangeStyle, isHovering, setIsHovering,
        handleMenuToggle, handleMenuItemClick} = props;

    const {menuItems} = ContractorTabsApp(props);

    return (<>
        <ul className={isMenuOpen ? 'largeMenu' : 'shortMenu'}>
            {menuItems
                .filter((item) => !item.hide)
                .map((item, index) => (
                    <SubMenu
                        key={index}
                        name={item.name}
                        isMenuOpen={isMenuOpen}
                        url={item.url}
                        isHovering={isHovering}
                        numHovering={item.isHovering}
                        label={item.label}
                        menuId={`menu-${index}`}
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        setChangeStyle={setChangeStyle}
                        onClick={() => handleMenuItemClick(item.name)}
                        changeStyle={changeStyle}
                        Icon={item.icon}
                        onLeave={() => setIsHovering(0)}
                        onHover={() => setIsHovering(item.isHovering)}
                        onlyName={item.onlyName}
                    />
                ))}
            <Link to='#'>
                <li className={isMenuOpen ? 'profile_li' : 'profile_li_col'}>
                    <SidebarDropDownOption
                        changestyle={changeStyle}
                        hovereffect={isHovering}
                        isMenuOpen={isMenuOpen}
                        menutop={false}
                    />
                </li>
            </Link>
        </ul>
        <div className='border-bottom border-white'></div>
        </>
    );
};

export default ContractorTabs;
